import React from 'react';
import {getUserInfoObject} from "ubs-framework/v2/common/function";
import {MASTER_DATA_ACTION} from "ubs-framework/v2/common/constant";

const initialState = {
    socketId: '',
    orgId: '',
    openSidebar: false,
    uac: null,
    ownerId: [],
    userObj: {},
    findUserIdsList: [],
    accessLevelObj: {},
    findAccessLevelIdsList: [],
    candidateObj: {},
    findCandidateIdsList: [],
    disqualifyReasonList: [],
    pipeLineTemplateList: [],
    jobTemplateList: [],
    interviewTypeList:[],
    experienceLevelList: [],
    atsJobDescriptionList: [],
    atsCompanyPerksList: [],
    statusList: [],
    priorityList: [],
    sideMenuActiveStep: 1,
    notificationCount: 0,
    commentCounter: [],
    generalSetting: {},
    relationWithApplicant:{},
    paymentbar:{}
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'AUTHENTICATE': {
            const data = {}
            if (action.payload) data.orgId = action.payload.orgId
            return {...state, ...data};
        }
        case 'ON_BOARDING_AUTHENTICATE': {
            const data = {}
            if (action.payload) data.orgId = action.payload.orgId
            if (action.payload) data.uac = true;
            return {...state, ...data};
        }
        case 'PRODUCT_ACCESS_REMOVED': {
            return {...state, uac: null};
        }
        case 'GET_ATS_MASTER_DATA': {
            console.log(`%c ATS UAACCC ===>`, 'font-weight: bolder; font-size: 14px; color: #ff6961; background-color: rgba(34, 101, 0, 0.1)', action?.payload?.uacInfo?.uac);
            return {
                ...state,
                uac: action?.payload?.uacInfo?.uac,
                uacID: action?.payload?.uacInfo?._id,
                userType: action?.payload?.uacInfo?.type,
                ownerId: action?.payload?.ownerId,
                disqualifyReasonList: action?.payload?.disqualifyReasonList?.map(e => ({...e, label: e.name, value: e._id})),
                pipeLineTemplateList: action?.payload?.pipeLineTemplateList?.map(e => ({...e, label: e.name, value: e._id})),
                jobTemplateList: action?.payload?.jobTemplateList?.map(e => ({...e, label: e.name, value: e._id})),
                tagsForCandidateList: action?.payload?.tagsForCandidateList?.map(e => ({...e, label: e.name, value: e._id})),
                tagsForJobList: action?.payload?.tagsForJobList?.map(e => ({...e, label: e.name, value: e._id})),
                atsDepartmentList: action?.payload?.atsDepartmentList?.map(e => ({...e, label: e.name, value: e._id})) || [],
                atsJobTitleList: action?.payload?.atsJobTitleList?.map(e => ({...e, label: e.name, value: e._id})) || [],
                atsLocationList: action?.payload?.atsLocationList?.map(e => ({...e, label: e.name, value: e._id})) || [],
                experienceLevelList: action?.payload?.experienceLevelList?.map(e => ({...e, label: e.name, value: e._id})),
                degreeList: (action?.payload?.degreeList?.map(e => ({...e, label: e.name, value: e._id})) || []).sort((a, b) => (a?.name || '').localeCompare(b?.name || '')),
                atsJobDescriptionList: action?.payload?.atsJobDescriptionList?.map(e => ({...e, label: e.name, value: e._id})),
                atsCompanyPerksList: action?.payload?.atsCompanyPerksList?.map(e => ({...e, label: e.name, value: e._id})),
                jobTypeList: action?.payload?.jobTypeList?.map(e => ({...e, label: e.name, value: e._id})),
                atsSkillList: action?.payload?.atsSkillList?.map(e => ({...e, label: e.name, value: e._id})),
                reasonToChangeList: action?.payload?.reasonToChangeList?.map(e => ({...e, label: e.name, value: e._id})),
                rejectReasonList: action?.payload?.rejectReasonList?.map(e => ({...e, label: e.name, value: e._id})),
                statusList: action?.payload?.statusList?.map(e => ({...e, label: e.name, value: e._id})),
                priorityList: action?.payload?.priorityList?.map(e => ({...e, label: e.name, value: e._id})),
                interviewTypeList: action?.payload?.interviewTypeList?.map(e => ({...e, label: e.name, value: e._id})),
                relationWithApplicant: action?.payload?.relationWithApplicant?.map((e,i) => ({...e, label: e, value: e})),
                notificationCount: action.payload?.notificationCount ?? 0,
                isDisplayReleaseNotification: action.payload?.uacInfo?.isDisplayReleaseNotification,
                generalSetting: action?.payload?.generalSetting
            };
        }
        case 'GET_PAYMENT_BAR_DATA': {
            return {...state, paymentbar: action?.payload};
        }
        case 'SET_INTEGRATION': {
            const integration = {
                ['zoom']: action?.payload?.zoom,
                ['google-meet']: action?.payload?.google,
                ['microsoft-teams']: action?.payload?.msTeams,
            }
            return {...state, integration};
        }
        case 'UPDATE_INTEGRATION': {
            const integration = {
                ...state.integration,
                ...(action?.payload?.zoomAuthDeatil && {['zoom']: action?.payload?.zoomAuthDeatil}),
                ...(action?.payload?.googleAuthDeatil && {['google-meet']: action?.payload?.googleAuthDeatil}),
                ...(action?.payload?.microsoftAuthDetail && {['microsoft-teams']: action?.payload?.microsoftAuthDetail}),
            }
            return {...state, integration};
        }
        case 'REMOVE_INTEGRATION': {
            const integration = {
                ...state.integration,
                ...(action?.payload?.zoom_id && {['zoom']: null}),
                ...(action?.payload?.google_id && {['google-meet']: null}),
                ...(action?.payload?.teams_id && {['microsoft-teams']: null}),
            }
            return {...state, integration};
        }
        case 'UPDATE_ATS_MASTER_DATA': {
            const key = Object.keys(action.payload?.payload)?.[0]
            const value = action.payload?.payload?.[key]
            let localState = null
            if (state[key]) localState = JSON.parse(JSON.stringify(state[key]));

            switch (action.payload.action) {
                case MASTER_DATA_ACTION.ADD : {
                    localState?.push(value)
                    break;
                }
                case MASTER_DATA_ACTION.UPDATE : {
                    localState = localState?.map(e => {
                        if (e._id === value?._id) return {...e, ...value}
                        else return e
                    })
                    break;
                }
                case MASTER_DATA_ACTION.REPLACE : {
                    localState = value
                    break;
                }
                case MASTER_DATA_ACTION.DELETE : {
                    localState = localState?.filter(e => e._id !== value?._id)
                    break;
                }
            }

            return {...state, [key]: localState};
        }
        case 'OPEN_SIDEBAR': {
            return {...state, openSidebar: action.payload};
        }
        case 'FIND_MASTER_DATA_LIST': {
            return {
                ...state,
                ...(action?.payload?.findUserIdsList?.length && {findUserIdsList: action?.payload?.findUserIdsList}),
                ...(action?.payload?.findAccessLevelIdsList?.length && {findAccessLevelIdsList: action?.payload?.findAccessLevelIdsList}),
                ...(action?.payload?.findCandidateIdsList?.length && {findCandidateIdsList: action?.payload?.findCandidateIdsList}),
            }
        }
        case 'GET_CANDIDATE_INFO_UPDATE': {
            // Keyed by _id so a screen holding only ids can read the photo/name straight out.
            const candidateObj = {...state.candidateObj};

            action?.payload?.candidateList?.forEach(e => {
                if (e?._id) candidateObj[e._id] = e;
            })

            return {...state, candidateObj}
        }
        case 'GET_MASTER_INFO_UPDATE': {
            const userObj = JSON.parse(JSON.stringify(state.userObj));
            const accessLevelObj = JSON.parse(JSON.stringify(state.accessLevelObj));

            // set user object
            if (action?.payload && action?.payload?.users?.length !== 0) {
                action?.payload?.users?.map(e => {
                    userObj[e._id] = getUserInfoObject(e)
                })
            }

            // set access level object
            if (action?.payload && action?.payload?.accessLevel?.length !== 0) {
                action?.payload?.accessLevel?.map(e => {
                    accessLevelObj[e._id] = e
                })
            }

            return {...state, userObj, accessLevelObj}
        }
        case 'CHANGE_SIDE_MENU_ACTIVE_STEP': {
            return {...state, sideMenuActiveStep: action.payload}
        }
        case 'UPDATE_NOTIFICATION_COUNT': {
            return {...state, notificationCount: action?.payload}
        }
        case 'SET_COMMENT_COUNTER': {
            return {...state, commentCounter: action?.payload};
        }
        default: {
            return state;
        }
    }
}
